import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';
import { toISOString } from '../../common/functions';
import { getVertexId } from '../../core/util';

export default (
  division: CoreTypes.Mixed.Division,
  options:  SduiTypes.options
): SduiTypes.schoolYear => {
  const begins_at = toISOString(division.start);
  if (!begins_at)
    throw new Error(`(Sdui::to::SchoolYear) Start is not missing for division ${ getVertexId(division, options) }`);

  const ends_at = toISOString(division.end);
  if (!ends_at)
    throw new Error(`(Sdui::to::SchoolYear) End is not missing for division ${ getVertexId(division, options) }`);

  return {
    begins_at,
    ends_at
  };
};
